import gql from 'graphql-tag';
import { leadFragments } from './leads.queries';

export const GET_ORGANIZATION_LEADS_REPORT = gql`
  query getOrganizationLeadsReport(
    $page: Int
    $organizationRevvUid: String
    $limit: Int
    $dateRangeStart: String
    $dateRangeEnd: String
    $sourceType: LeadSourceEnum
    $search: String
    $ignoreCustomFields: Boolean
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        export_leads_report(
          filters: {
            page: $page
            limit: $limit
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            sourceType: $sourceType
            search: $search
            ignoreCustomFields: $ignoreCustomFields
          }
        )
      }
    }
  }
`;

export const GET_ORGANIZATION_LEADS_QUERY = gql`
  query getOrganizationLeads(
    $page: Int
    $organizationRevvUid: String
    $limit: Int
    $dateRangeStart: String
    $dateRangeEnd: String
    $sourceType: LeadSourceEnum
    $search: String
  ) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        leads(
          filters: {
            page: $page
            limit: $limit
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            sourceType: $sourceType
            search: $search
          }
        ) {
          ...Leads
        }
      }
    }
  }
  ${leadFragments.leads}
`;

export const GET_ORGANIZATION_LEAD_QUERY = gql`
  query getOrganizationLead($revv_uid: String, $organizationRevvUid: String) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        leads(filters: { revvUid: $revv_uid }) {
          ...Lead
        }
      }
    }
  }
  ${leadFragments.lead}
`;
